module.exports = __webpack_public_path__ + "static/clipagem-a0aac8996adb82a0195aa3db63d6e73a.png";